// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1d-q";
export var animationRelative = "_1d-p";
export var backdropBlur = "_1d-0";
export var detailLabelCell = "_1d-12";
export var detailTable = "_1d-11";
export var detailValueCell = "_1d-13";
export var docIconBox = "_1d-1d";
export var docIconBoxMd = "_1d-1f";
export var docIconBoxSm = "_1d-1e";
export var docTypeRow = "_1d-16";
export var docTypeRowInner = "_1d-17";
export var dropdownMatchDatePicker = "_1d-3";
export var evidenceCardContent = "_1d-1c";
export var fileUploadSpin = "_1d-j";
export var gorgiasOpenButton = "_1d-15 _1d-d";
export var gorgiasTicketCard = "_1d-14";
export var heroModalFooterButton = "_1d-18";
export var hiddenContainer = "_1d-o";
export var iconPrimary = "_1d-1g";
export var iconQuaternary = "_1d-1i";
export var iconTertiary = "_1d-1h";
export var integrationCard = "_1d-1";
export var integrationLogoBox = "_1d-2";
export var mainColumnSticky = "_1d-1b";
export var maxWidthContainer = "_1d-19";
export var modalContentBody = "_1d-a";
export var modalHeaderImage = "_1d-5";
export var modalImageLabel = "_1d-7";
export var modalImageOverlay = "_1d-6";
export var modalImageSubtitle = "_1d-9";
export var modalImageTitle = "_1d-8";
export var modalImageWrapper = "_1d-4";
export var modalStickyFooter = "_1d-b";
export var removeButton = "_1d-e";
export var sidebarColumn = "_1d-1a";
export var spinner = "_1d-i";
export var timelineLine = "_1d-y";
export var timelineLineBlack = "_1d-10 _1d-y";
export var timelineLineGray = "_1d-z _1d-y";
export var timelineLineHeight = "_1d-x";
export var tlDotActivate = "_1d-u";
export var tlDotActivateAnim = "_1d-t";
export var tlDotHide = "_1d-s";
export var tlDotHideAnim = "_1d-r";
export var tlLineActivate = "_1d-w";
export var tlLineActivateAnim = "_1d-v";
export var uploadHint = "_1d-n";
export var uploadIconBox = "_1d-k";
export var uploadLabel = "_1d-m";
export var uploadText = "_1d-l";
export var uploadZone = "_1d-f";
export var uploadZoneCursorDefault = "_1d-h";
export var uploadZoneCursorPointer = "_1d-g";
export var uploadedFileRow = "_1d-c";
export var viewButton = "_1d-d";